import * as React from 'react'

import PropTypes from 'prop-types'

import styleNames from '@pareto-engineering/bem/exports'

import { Card, Label } from '@pareto-engineering/design-system'

import './styles.scss'

// Local Definitions

const baseClassName = styleNames.base

const componentClassName = 'testimonial-card'

/**
 * This is the component description.
 */
const TestimonialCard = ({
  id,
  className:userClassName,
  style,
  testimonial,
  rating,
  ratingColor,
  labels,
  name,
  image,
  role,
  company,
  // ...otherProps
}) => {
  const filledStarCount = rating ? Array(rating).fill() : null

  return (
    <Card
      id={id}
      className={[
        baseClassName,
        componentClassName,
        userClassName,
      ]
        .filter((e) => e)
        .join(' ')}
      style={style}
    >
      {rating && (
        <Card.Section>
          <div className={`rating x-${ratingColor}`}>
            {filledStarCount.map(() => (
              <span className="icon">
                [
              </span>
            ))}
            {Array(5 - rating).fill('').map(() => (
              <span className="icon">
                (
              </span>
            ))}
          </div>
          <p>
            &quot;
            {testimonial}
            &quot;
          </p>
        </Card.Section>
      )}
      <Card.Section>
        <div className="person">
          {image && <img className="image" src={image} alt={`${name}, ${role}`} />}
          <div className="details">
            <p className="name">{name}</p>
            <p className="role">{`${role}${company ? ` @ ${company}` : ''}`}</p>
          </div>
        </div>
        {labels && (
          <div className="labels">
            {labels.map((label) => (
              <Label isCompact>
                {label}
              </Label>
            ))}
          </div>
        )}
        {!rating && (
        <p>
          &quot;
          {testimonial}
          &quot;
        </p>
        )}
      </Card.Section>
    </Card>
  )
}

TestimonialCard.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   * The testimonial to display
   */
  testimonial:PropTypes.string,

  /**
   * The number of stars to display, if any
   */
  rating:PropTypes.number,

  /**
   * The color of the rating stars
   */
  ratingColor:PropTypes.string,

  /**
   * The number of stars to display, if any
   */
  labels:PropTypes.arrayOf(PropTypes.string),

  /**
   * The person's image
  */
  image:PropTypes.string.isRequired,

  /**
   * The person's name
   */
  name:PropTypes.string.isRequired,

  /**
   *  The person's role
   */
  role:PropTypes.string.isRequired,

  /**
   * The person's company
   */
  company:PropTypes.string.isRequired,
}

TestimonialCard.defaultProps = {
  ratingColor:'main',
}

TestimonialCard.Group = Card.Group

export default TestimonialCard
